import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-receipt-approval',
  templateUrl: './payment-receipt-approval.component.html',
  styleUrls: ['./payment-receipt-approval.component.css']
})
export class PaymentReceiptApprovalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/payment-receipt-approval/payment-receipt-approval.component.ts